export enum SpousalWaiverTypeEnum {
  MonthlyPensionSetUp = 1,
  VariableBenefitConfiguration = 2,
  PreRetirementBeneficiary = 3,
  VariableBenefitBeneficiary = 4,
  MonthlyPensionBeneficiary = 5,
  TransferOut = 6,
  Unlocking = 7,
  SurvivingSpouse = 8
}
